import React from 'react';
import { Modal } from '../ui/Modal';
import { Button } from '../ui/Button';
import { AlertCircle } from 'lucide-react';
interface CloseoutConfirmationModalProps {
  isOpen: boolean;
  onClose: () => void;
  action: 'mark-production' | 'reopen';
  storeName: string;
  onConfirm: () => void;
}
export function CloseoutConfirmationModal({
  isOpen,
  onClose,
  action,
  storeName,
  onConfirm
}: CloseoutConfirmationModalProps) {
  const getContent = () => {
    if (action === 'mark-production') {
      return {
        title: 'Mark Store In Production?',
        message: `Are you sure you want to mark "${storeName}" as In Production? This will update the store status and notify relevant stakeholders.`,
        confirmText: 'Mark In Production',
        confirmVariant: 'primary' as const
      };
    } else {
      return {
        title: 'Reopen Store?',
        message: `Are you sure you want to reopen "${storeName}"? This will allow customers to place new orders.`,
        confirmText: 'Reopen Store',
        confirmVariant: 'danger' as const
      };
    }
  };
  const content = getContent();
  return <Modal isOpen={isOpen} onClose={onClose} title={content.title} size="sm" footer={<>
          <Button variant="outline" onClick={onClose} data-id="element-48">
            Cancel
          </Button>
          <Button variant={content.confirmVariant} onClick={onConfirm} data-id="element-49">
            {content.confirmText}
          </Button>
        </>} data-id="element-47">
      <div className="space-y-4" data-id="element-50">
        <div className="flex items-start space-x-3" data-id="element-51">
          <AlertCircle className="h-5 w-5 text-yellow-600 mt-0.5" data-id="element-52" />
          <p className="text-sm text-gray-700" data-id="element-53">{content.message}</p>
        </div>
      </div>
    </Modal>;
}